import React, { useEffect, useState } from 'react'
import Post from './Post'
import ReactPaginate from "react-paginate";
import { db } from '../../../firebase';
import CommonHeader from "../../../sub-components/CommonHeader"
import Slider1 from "../../../sub-components/MenuCategory/Slider1"
import Footer from "../../../sub-components/Footer"


function Menus({ id1 }) {
  const [posts, setPosts] = useState([])
  const [pageNumber, setPageNumber] = useState(0);
  const [input, setInput] = useState("");
  const [posts1, setPosts1] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredPosts, setFilteredPosts] = useState([]);

  
  useEffect(() => {
    db.collection('menus').onSnapshot((snapshot) => {
      setPosts1(snapshot.docs.map((doc) => doc.data()))
    })

    if (posts1 !== undefined) {
      const finalPosts = posts1.filter(res => {
        return res.menuName.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1
        // console.log("sth is in: ",res.menuName.toLowerCase())
      })

      setFilteredPosts(finalPosts)
    }else {
      return <div>No results3</div>
    }
  }, [searchTerm])

  const updateSearchResults = (e) => {
    setSearchTerm(e.target.value)
    // document.getElementsByClassName('dropdown-content3')[0].style.display = 'auto';
  }

  const totalRatings = (posts.reduce((a,v) =>  a = a + v.post.rating , 0 ))
  const numberOfRatings = posts.length
  const rating = totalRatings / numberOfRatings
  var a = Math.round(rating * 10) / 10

   useEffect(() => {
       db.collection('menus').onSnapshot(snapshot => {
           setPosts(snapshot.docs.map(doc => ({
               id: doc.id,
               post: doc.data(),
           })));
       })
   }, []);
   const menusPerPage = 9;
   const pagesVisited = pageNumber * menusPerPage;

   const displayMenus = <div>

       <section className="section pt-5 pb-5 products-listing">
         <div className="container">
 
           <div>
         {/* SideBar here */}
             <div className="">

            <form className="explore-outlets-search mb-4 rounded overflow-hidden border">
       <div className="input-group">
         <input type="text" onChange={updateSearchResults} placeholder="Search for menus..." className="form-control border-0" />
         <div className="input-group-append">
           <button type="button" className="btn btn-primary">
             <i className="icofont-search" />
           </button>
         </div>
       </div>
     </form>
             <div className="product-list-view">
   
           <div className="row">
             {searchTerm === "" ?(
                  <>
                             {
             // hakuna > || iko < 
             posts.length > 0 ?(
               <>
               {
                              posts.slice(pagesVisited, pagesVisited + menusPerPage).map(({id, post}) => (
                                 <Post
                                 key={id} 
                                 mealImage={post.mealImage}
                                 branchId={post.branchId}
                                 createdById={post.createdBy}
                                 mealArrayIds={post.mealArrayIds}
                                 menuName={post.menuName}
                                 menuCategories={post.menuCategories}
                                 rating={post?.rating}
                                 restId={post.restId}
                                 timestamp={post.timestamp}
                                 menuAvailability={post?.menuAvailability}
                                 menuId={id}
                                 numberOfRatings={post?.numberOfRatings}
                                 totalRates={a}
                                 restaurant={post?.restaurant}
                                 CategoryId={id1}
                                 />
                               ))
               }
               </>
             ) : (<>  <center><i style={{fontSize:18,fontWeight:'bold'}}>Loading...</i></center>
             </>)  
   } 
                  </>
             ):(
               <>
                            <div className="product-list-view">
   <div className="row">
            {
              filteredPosts.length > 0 ?(
                <>
                {
                                filteredPosts.map((posts2) => (

<Post 
mealImage={posts2.mealImage}
branchId={posts2.branchId}
createdById={posts2.createdBy}
mealArrayIds={posts2.mealArrayIds}
menuName={posts2.menuName}
menuCategories={posts2.menuCategories}
rating={posts2?.rating}
restId={posts2.restId}
timestamp={posts2.timestamp}
menuAvailability={posts2?.menuAvailability}
menuId={posts2?.menuId}
numberOfRatings={posts2?.numberOfRatings}
totalRates={a}
restaurant={posts2?.restaurant}
CategoryId={id1}
/>
    ))
                                }
                </>
              ):(
                <><center style={{fontWeight:'bold'}}><h4>No results...</h4></center></>
              )

              
            
            }
          </div>
          </div>
               </>
             )}

     </div>
     </div>
   
              
   
             </div>
           </div>
         </div>
       </section>
   
   
   
   
   </div>

 const pageCount = Math.ceil(posts.length / menusPerPage);
 const changePage = ({ selected }) => {
   setPageNumber(selected);
 };


  return (
   <div>
     {displayMenus}
     <center>
       
     <ReactPaginate
        previousLabel={"Previous"}
        nextLabel={"Next"}
        pageCount={pageCount}
        pageCountClassName={"pagecount"}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
     </center>

   </div>
  )
}

export default Menus




